export default function(value) {
  if (!value) {
    return value;
  }
  value = parseFloat(value).toFixed(0);
  let filteredValue = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return filteredValue;
}
